(function () {
  var root = document.getElementById('compare-root');

  function getThumbW() {
    return window.innerWidth <= 640 ? 108 : 130;
  }
  var THUMB_GAP = 10;

  function getItems() {
    try { return JSON.parse(localStorage.getItem('compareItems') || '[]'); } catch (e) { return []; }
  }

  var items = getItems();
  if (items.length < 1) {
    root.innerHTML = '<div class="empty-state"><p>No products added to compare.</p><a href="/collections/explore-all-wall-art">Browse products</a></div>';
    return;
  }

  var slotA = 0;
  var slotB = items.length > 1 ? 1 : 0;
  var _dragIndex = -1;
  var _selectedSlot = null;
  var _variantState = {};
  var _selectedOptions = {};
  var _productCache = {};



  /* ── helpers ── */
  function shortTitle(t, len) {
    t = (t || '').split('|')[0].split('—')[0].trim();
    return t.length > len ? t.substring(0, len) + '…' : t;
  }
  function optValByName(p, name) {
    var opt = (p.options || []).find(function (o) { return o.name === name; });
    return opt ? opt.values.join(', ') : '—';
  }
  function allOptionNames(pA, pB) {
    var names = [];
    [pA, pB].forEach(function (p) {
      (p.options || []).forEach(function (o) {
        if (names.indexOf(o.name) === -1) names.push(o.name);
      });
    });
    return names;
  }
  function getHandle(p) {
    return p.handle || (p.url || '').replace('/products/', '').split('?')[0].split('/')[0];
  }
  function fetchProduct(handle, cb) {
    if (_productCache[handle]) { cb(_productCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { _productCache[handle] = d; cb(d); })
      .catch(function () { cb(null); });
  }
  function variantImageSrc(prod, variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_image && variant.featured_image.position && prod.images) {
      var pos = variant.featured_image.position - 1;
      if (prod.images[pos]) return prod.images[pos].src;
    }
    return null;
  }
  function slotImage(itemIdx) {
    var state = _variantState[itemIdx];
    if (state && state.variantImage) return state.variantImage;
    return items[itemIdx] ? items[itemIdx].image : '';
  }
  function swapImage(el, newSrc) {
    if (!el || !newSrc) return;
    el.style.opacity = '0.3';
    setTimeout(function () { el.src = newSrc; el.style.opacity = '1'; }, 150);
  }
  function updateBlip(count) {
    document.querySelectorAll('.cart-blip').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
        var a = el.closest('a');
        if (a) a.classList.add('has-blip-visible');
      } else {
        el.setAttribute('hidden', '');
        var a = el.closest('a');
        if (a) a.classList.remove('has-blip-visible');
      }
    });
  }
  function iconFor(name) {
    var lc = name.toLowerCase();
    if (lc.indexOf('frame') !== -1) return 'border-outer';
    if (lc.indexOf('size') !== -1) return 'ruler-2';
    if (lc.indexOf('canvas') !== -1) return 'texture';
    if (lc.indexOf('finish') !== -1) return 'sparkles';
    if (lc.indexOf('material') !== -1) return 'layers-intersect';
    if (lc.indexOf('colour') !== -1 || lc.indexOf('color') !== -1) return 'palette';
    if (lc.indexOf('medium') !== -1) return 'brush';
    if (lc.indexOf('style') !== -1) return 'wand';
    return 'tag';
  }

  /* ── progress bar refresh ── */
  function refreshProgressBar() {
    if (typeof window.TPB === 'undefined') return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        var s1 = document.getElementById('tpb-s1');
        var s2 = document.getElementById('tpb-s2');
        var n1 = document.getElementById('tpb-n1');
        var n2 = document.getElementById('tpb-n2');
        var l1 = document.getElementById('tpb-l1');
        var l2 = document.getElementById('tpb-l2');
        var msg = document.getElementById('tpb-msg');
        if (!s1 || !msg) return;
        var T1 = window.TPB.T1;
        var T2 = window.TPB.T2;
        s1.style.width = Math.min(total / T1 * 100, 100).toFixed(1) + '%';
        if (s2) s2.style.width = (total >= T1 ? Math.min((total - T1) / (T2 - T1) * 100, 100) : 0).toFixed(1) + '%';
        if (n1) n1.classList.toggle('active', total >= T1);
        if (n2) n2.classList.toggle('active', total >= T2);
        if (l1) l1.classList.toggle('active', total >= T1);
        if (l2) l2.classList.toggle('active', total >= T2);
        if (window.TPB.MSG0 && total < T1) {
          var r1 = T1 - total;
          msg.innerHTML = window.TPB.MSG0.replace ? window.TPB.MSG0.replace('[amount]', '&#8377;' + Math.ceil(r1 / 100).toLocaleString('en-IN')) : window.TPB.MSG0;
        } else if (window.TPB.MSG1 && total >= T1 && total < T2) {
          var r2 = T2 - total;
          msg.innerHTML = window.TPB.MSG1.replace ? window.TPB.MSG1.replace('[amount]', '&#8377;' + Math.ceil(r2 / 100).toLocaleString('en-IN')) : window.TPB.MSG1;
        } else if (window.TPB.MSG2) {
          msg.innerHTML = window.TPB.MSG2;
        }
      })
      .catch(function () {});
  }

  /* ── cart refresh ── */
  function refreshThemeCart(onDone) {
    var SECTION_ID = 'sections--27206382059837__header';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBlip(cart.item_count);
        fetch('/?sections=' + SECTION_ID)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[SECTION_ID];
            if (!html) { if (onDone) onDone(); return; }
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var currentDrawer = document.querySelector('#drawer-cart');
            if (!currentDrawer) { if (onDone) onDone(); return; }
            ['#cart-items', '#cart-footer'].forEach(function (sel) {
              var newEl = doc.querySelector(sel);
              var curEl = currentDrawer.querySelector(sel);
              if (newEl && curEl) curEl.outerHTML = newEl.outerHTML;
            });
            refreshProgressBar();
            if (onDone) onDone();
          })
          .catch(function () { if (onDone) onDone(); });
      })
      .catch(function () { if (onDone) onDone(); });
  }

  /* ════════════════════════════════════════
     FRAME PICKER — updates image on selection
  ════════════════════════════════════════ */

  function loadFramePickers() {
    [{ idx: slotA, side: 'A' }, { idx: slotB, side: 'B' }].forEach(function (obj) {
      var p = items[obj.idx];
      if (!p) return;
      var handle = getHandle(p);
      if (!handle) return;

      fetchProduct(handle, function (prod) {
        if (!prod || !prod.variants) return;

        // ── Init variant state from first available variant ──
        if (!_variantState[obj.idx]) {
          var firstV = prod.variants.find(function (v) { return v.available; }) || prod.variants[0];
          var img = variantImageSrc(prod, firstV) || p.image;
          _variantState[obj.idx] = { variantId: firstV.id, variantImage: img };
          _selectedOptions[obj.idx] = {};
          (prod.options || []).forEach(function (opt, i) {
            _selectedOptions[obj.idx][opt.name] = firstV.options[i];
          });
        }

        // ── Sync product image ──
        var currentImg = slotImage(obj.idx);
        var imgEl = document.getElementById('vimg-' + obj.side);
        if (imgEl && imgEl.src !== currentImg) imgEl.src = currentImg;

        var sel = _selectedOptions[obj.idx];

        // ── Populate each DETAIL_ROW cell ──
        DETAIL_ROWS.forEach(function (row) {
          var cell = document.getElementById('dt-' + obj.side + '-' + row.key);
          if (!cell) return;

          if (row.type === 'frame') {
            var frameOpt = (prod.options || []).find(function (o) {
              return o.name.toLowerCase().indexOf('frame') !== -1;
            });
            if (!frameOpt || frameOpt.values.length < 2) { cell.innerHTML = '<span class="dt-na">—</span>'; return; }

            var frameValues = frameOpt.values.slice(0, 3);
            var btns = frameValues.map(function (val) {
              var isSel = sel[frameOpt.name] === val;
              var avail = prod.variants.some(function (v) {
                return v.available && v.options.indexOf(val) !== -1;
              });
              var safeOptName = frameOpt.name.replace(/'/g, "\\'");
              var safeVal = val.replace(/'/g, "\\'");
              var lc = val.toLowerCase();
              var displayLabel = lc.indexOf('canvas') !== -1 ? 'Canvas'
                : lc.indexOf('black') !== -1 ? 'Black Floater'
                : lc.indexOf('golden') !== -1 || lc.indexOf('gold') !== -1 ? 'Golden Floater'
                : val;
              return '<button type="button" class="dt-tab' + (isSel ? ' selected' : '') + (avail ? '' : ' soldout') + '" '
                + 'onclick="cpFrameSelect(' + obj.idx + ',\'' + obj.side + '\',\'' + safeOptName + '\',\'' + safeVal + '\')">'
                + displayLabel + '</button>';
            }).join('');
            cell.innerHTML = '<div class="dt-tabs">' + btns + '</div>';

          } else if (row.type === 'size') {
            var sizeOpt = (prod.options || []).find(function (o) {
              return o.name.toLowerCase().indexOf('size') !== -1;
            });
            if (!sizeOpt || !sizeOpt.values.length) { cell.innerHTML = '<span class="dt-na">—</span>'; return; }
            var chips = sizeOpt.values.map(function (v) {
              return '<span class="dt-chip">' + v + '</span>';
            }).join('');
            cell.innerHTML = '<div class="dt-chips">' + chips + '</div>';

          } else if (row.type === 'rooms') {
            var rooms = getRoomsForProduct(p);
            var chips = rooms.map(function (r) {
              return '<span class="dt-room-chip"><i class="ti ti-' + r.icon + '"></i>' + r.label + '</span>';
            }).join('');
            cell.innerHTML = '<div class="dt-chips">' + chips + '</div>';
          }
        });
      });
    });
  }

  window.cpFrameSelect = function (itemIdx, side, optionName, value) {
    var p = items[itemIdx];
    if (!p) return;
    fetchProduct(getHandle(p), function (prod) {
      if (!prod) return;
      if (!_selectedOptions[itemIdx]) _selectedOptions[itemIdx] = {};
      _selectedOptions[itemIdx][optionName] = value;

      var selArr = (prod.options || []).map(function (o) { return _selectedOptions[itemIdx][o.name]; });
      var variant = prod.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selArr[i]; });
      });
      if (!variant) {
        variant = prod.variants.find(function (v) { return v.options.indexOf(value) !== -1; }) || prod.variants[0];
        (prod.options || []).forEach(function (o, i) { _selectedOptions[itemIdx][o.name] = variant.options[i]; });
      }

      var displayImg = variantImageSrc(prod, variant) || p.image;
      _variantState[itemIdx] = { variantId: variant.id, variantImage: displayImg };
      swapImage(document.getElementById('vimg-' + side), displayImg);
      swapImage(document.getElementById('slotimg-' + side), displayImg);
      swapImage(document.getElementById(side === 'A' ? 'revealImgTop' : 'revealImgBase'), displayImg);
      loadFramePickers();
    });
  };

  /* ── add to cart ── */
  window.cpAddToCart = function (itemIdx, btn) {
    var p = items[itemIdx];
    if (!p) return;
    function doAdd(variantId) {
      if (!variantId) { window.location.href = p.url; return; }
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓ Added!';
        btn.style.background = '#4caf50';
        btn.style.color = '#fff';
        refreshThemeCart(function () {
          var cartLinks = document.querySelectorAll('a[href="#drawer-cart"]');
          cartLinks.forEach(function (el) {
            if (!el.closest('#drawer-cart') && !el.closest('#drawer-menu')) el.click();
          });
        });
        setTimeout(function () {
          btn.textContent = 'Add to cart';
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function (err) {
        console.error('ATC error:', err);
        btn.textContent = 'View product →';
        btn.disabled = false;
        btn.onclick = function () { window.location.href = p.url; };
      });
    }
    if (_variantState[itemIdx] && _variantState[itemIdx].variantId) {
      doAdd(_variantState[itemIdx].variantId);
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Loading…';
    var handle = getHandle(p);
    if (!handle) { window.location.href = p.url; return; }
    fetchProduct(handle, function (prod) {
      if (!prod || !prod.variants || !prod.variants.length) { window.location.href = p.url; return; }
      var v = prod.variants.find(function (x) { return x.available; }) || prod.variants[0];
      var img = variantImageSrc(prod, v) || p.image;
      _variantState[itemIdx] = { variantId: v.id, variantImage: img };
      doAdd(v.id);
    });
  };

  /* ════════════════════════════════════════
     CAROUSEL HELPERS
  ════════════════════════════════════════ */
  function getVisibleCount(trackWrap) {
    var ww = trackWrap ? trackWrap.clientWidth : 300;
    var tw = getThumbW();
    return Math.max(1, Math.floor((ww + THUMB_GAP) / (tw + THUMB_GAP)));
  }
  function getPageCount(trackWrap) {
    return Math.max(1, Math.ceil(items.length / getVisibleCount(trackWrap)));
  }
  function getScrollPage(trackWrap) {
    var pageW = getVisibleCount(trackWrap) * (getThumbW() + THUMB_GAP);
    return Math.round(trackWrap.scrollLeft / pageW);
  }
  function scrollToPage(trackWrap, idx) {
    var pageW = getVisibleCount(trackWrap) * (getThumbW() + THUMB_GAP);
    trackWrap.scrollTo({ left: idx * pageW, behavior: 'smooth' });
  }
  function updateCarouselState(trackWrap, dotsEl, arrowPrev, arrowNext, fadeLeft, fadeRight) {
    var sl = trackWrap.scrollLeft;
    var maxScroll = trackWrap.scrollWidth - trackWrap.clientWidth;
    var atStart = sl <= 2;
    var atEnd = sl >= maxScroll - 2;
    var noOverflow = maxScroll <= 1;
    arrowPrev.classList.toggle('hidden', atStart || noOverflow);
    arrowNext.classList.toggle('hidden', atEnd || noOverflow);
    fadeLeft.style.opacity = (atStart || noOverflow) ? '0' : '1';
    fadeRight.style.opacity = (atEnd || noOverflow) ? '0' : '1';
    var pips = dotsEl.querySelectorAll('.cp-dot');
    var cur = getScrollPage(trackWrap);
    pips.forEach(function (p, i) { p.classList.toggle('active', i === cur); });
  }
  function buildDots(dotsEl, trackWrap) {
    dotsEl.innerHTML = '';
    var pages = getPageCount(trackWrap);
    if (pages <= 1) return;
    for (var i = 0; i < pages; i++) {
      var btn = document.createElement('button');
      btn.className = 'cp-dot' + (i === 0 ? ' active' : '');
      btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
      (function (idx) {
        btn.addEventListener('click', function () { scrollToPage(trackWrap, idx); });
      })(i);
      dotsEl.appendChild(btn);
    }
  }
  function initCarousel(carouselOuter) {
    var trackWrap = carouselOuter.querySelector('.cp-track-wrap');
    var dotsEl = carouselOuter.nextElementSibling;
    var arrowPrev = carouselOuter.querySelector('.cp-carousel-arrow.prev');
    var arrowNext = carouselOuter.querySelector('.cp-carousel-arrow.next');
    var fadeLeft = carouselOuter.querySelector('.cp-carousel-fade-left');
    var fadeRight = carouselOuter.querySelector('.cp-carousel-fade-right');
    buildDots(dotsEl, trackWrap);
    updateCarouselState(trackWrap, dotsEl, arrowPrev, arrowNext, fadeLeft, fadeRight);
    arrowPrev.addEventListener('click', function () {
      scrollToPage(trackWrap, Math.max(0, getScrollPage(trackWrap) - 1));
    });
    arrowNext.addEventListener('click', function () {
      scrollToPage(trackWrap, Math.min(getPageCount(trackWrap) - 1, getScrollPage(trackWrap) + 1));
    });
    trackWrap.addEventListener('scroll', function () {
      updateCarouselState(trackWrap, dotsEl, arrowPrev, arrowNext, fadeLeft, fadeRight);
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots(dotsEl, trackWrap);
        updateCarouselState(trackWrap, dotsEl, arrowPrev, arrowNext, fadeLeft, fadeRight);
      }, 120);
    });
  }

  /* ── build saved carousel ── */
  function buildSavedCarousel() {
    var thumbsHTML = items.map(function (p, i) {
      var inSlot = (i === slotA || i === slotB) ? ' in-slot' : '';
      var isActive = (_selectedSlot !== null && (
        (_selectedSlot === 'A' && i !== slotA) || (_selectedSlot === 'B' && i !== slotB)
      )) ? ' active-select' : '';
      return '<div class="saved-thumb' + inSlot + isActive + '" '
        + 'draggable="true" '
        + 'ondragstart="cpDragStart(event,' + i + ')" '
        + 'ondragend="cpDragEnd(event)" '
        + 'onclick="cpClickThumb(' + i + ')">'
        + '<button class="saved-thumb-x" onclick="event.stopPropagation();cpRemoveItem(' + i + ')" aria-label="Remove">✕</button>'
        + '<div class="saved-thumb-inner"><img src="' + p.image + '" alt="' + p.title + '" draggable="false"></div>'
        + '<div class="saved-thumb-label">' + shortTitle(p.title, 14) + '</div>'
        + '</div>';
    }).join('');

    return '<div class="cp-carousel-outer" id="cpCarouselOuter">'
      + '<button class="cp-carousel-arrow prev hidden" id="cpArrowPrev" aria-label="Scroll left"><i class="ti ti-chevron-left" aria-hidden="true"></i></button>'
      + '<button class="cp-carousel-arrow next hidden" id="cpArrowNext" aria-label="Scroll right"><i class="ti ti-chevron-right" aria-hidden="true"></i></button>'
      + '<div class="cp-carousel-fade-left" id="cpFadeLeft"></div>'
      + '<div class="cp-carousel-fade-right" id="cpFadeRight"></div>'
      + '<div class="cp-track-wrap" id="cpTrackWrap">'
        + '<div class="cp-track" id="cpTrack">' + thumbsHTML + '</div>'
      + '</div>'
    + '</div>'
    + '<div class="cp-dots" id="cpDots"></div>';
  }

  /* ── build swap hint ── */
  function buildSwapHint() {
    if (_selectedSlot) return '<p class="cp-swap-hint active">Tap a saved artwork above to swap it in ↑</p>';
    return '<p class="cp-swap-hint">Tap a slot to select · then tap a saved artwork · or drag &amp; drop</p>';
  }

  /* ── build compare slots ── */
  function buildCompareCols() {
    function slotHTML(p, isA) {
      var side = isA ? 'A' : 'B';
      var isSelected = _selectedSlot === side;
      var idx = isA ? slotA : slotB;
      if (p) {
        var imgSrc = slotImage(idx);
        var swapOverlay = isSelected ? '<div class="slot-swap-overlay">Tap an artwork to swap</div>' : '';
        return '<div class="compare-slot has-item' + (isSelected ? ' selected' : '') + '" id="slot' + side + '" '
          + 'ondragover="event.preventDefault();this.classList.add(\'drag-over\')" '
          + 'ondragleave="this.classList.remove(\'drag-over\')" '
          + 'ondrop="cpDrop(event,\'' + side + '\')" '
          + 'onclick="cpSelectSlot(\'' + side + '\')">'
          + '<button class="slot-remove" onclick="event.stopPropagation();cpClearSlot(' + (isA ? 'true' : 'false') + ')" aria-label="Remove">✕</button>'
          + '<img class="slot-img-full" id="slotimg-' + side + '" src="' + imgSrc + '" alt="' + p.title + '" draggable="false">'
          + swapOverlay
          + '</div>';
      }
      return '<div class="compare-slot' + (isSelected ? ' selected' : '') + '" id="slot' + side + '" '
        + 'ondragover="event.preventDefault();this.classList.add(\'drag-over\')" '
        + 'ondragleave="this.classList.remove(\'drag-over\')" '
        + 'ondrop="cpDrop(event,\'' + side + '\')" '
        + 'onclick="cpSelectSlot(\'' + side + '\')">'
        + '<div style="display:flex;flex-direction:column;align-items:center;">'
        + '<div class="slot-empty-icon"><i class="ti ti-plus" aria-hidden="true"></i></div>'
        + '<div class="slot-empty-text">Drag or tap<br>an artwork to compare</div>'
        + '</div></div>';
    }
    return '<div class="compare-cols">'
      + slotHTML(items[slotA], true)
      + '<div class="vs-pill"><div class="vs-line"></div><div class="vs-text">VS</div><div class="vs-line"></div></div>'
      + slotHTML(items[slotB], false)
      + '</div>';
  }

  /* ── build reveal slider — zoom-in only on both sides ── */
  function buildReveal() {
    var pA = items[slotA];
    var pB = items[slotB];
    if (!pA || !pB || slotA === slotB) {
      return '<div class="reveal-shell"><div class="reveal-empty">Select two artworks above to compare</div></div>';
    }
    var imgA = slotImage(slotA);
    var imgB = slotImage(slotB);
    return '<div class="reveal-shell">'
      + '<div class="reveal-arena" id="revealArena">'
        + '<div class="reveal-base"><img id="revealImgBase" src="' + imgB + '" alt=""></div>'
        + '<div class="reveal-top" id="revealTop"><img id="revealImgTop" src="' + imgA + '" alt=""></div>'
        + '<div class="reveal-line" id="revealLine"></div>'
        + '<div class="reveal-handle" id="revealHandle">⇄</div>'
        + '<div class="reveal-zoom left">'
          + '<button class="rz-btn" onclick="event.stopPropagation();cpOpenLightbox(document.getElementById(\'revealImgTop\').src)" title="Zoom in" aria-label="Zoom artwork A"><i class="ti ti-zoom-in" aria-hidden="true"></i></button>'
        + '</div>'
        + '<div class="reveal-zoom right">'
          + '<button class="rz-btn" onclick="event.stopPropagation();cpOpenLightbox(document.getElementById(\'revealImgBase\').src)" title="Zoom in" aria-label="Zoom artwork B"><i class="ti ti-zoom-in" aria-hidden="true"></i></button>'
        + '</div>'
      + '</div>'
    + '</div>';
  }

  /* ════════════════════════════════════════
     LIGHTBOX — click & pinch to zoom
  ════════════════════════════════════════ */
  var _lbScale = 1, _lbPanX = 0, _lbPanY = 0;
  var _lbMouseDragging = false, _lbStartX = 0, _lbStartY = 0;
  var _lbTouchDist = 0, _lbTouchMidX = 0, _lbTouchMidY = 0, _lbScaleAtPinchStart = 1;
  var _lbTouchPanning = false, _lbTouchStartX = 0, _lbTouchStartY = 0, _lbPanXAtStart = 0, _lbPanYAtStart = 0;

  function ensureLightbox() {
    if (document.getElementById('cpLightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'cpLightbox';
    lb.className = 'lb-overlay';
    lb.innerHTML =
      '<button class="lb-close" id="lbClose" aria-label="Close"><i class="ti ti-x" aria-hidden="true"></i></button>'
      + '<div class="lb-stage" id="lbStage"><img id="lbImg" src="" alt="Artwork full view"></div>'
      + '<div class="lb-controls">'
        + '<button class="lb-ctrl-btn" id="lbZoomOut" aria-label="Zoom out"><i class="ti ti-minus" aria-hidden="true"></i></button>'
        + '<button class="lb-ctrl-btn" id="lbZoomReset" aria-label="Reset zoom"><i class="ti ti-aspect-ratio" aria-hidden="true"></i></button>'
        + '<button class="lb-ctrl-btn" id="lbZoomIn" aria-label="Zoom in"><i class="ti ti-plus" aria-hidden="true"></i></button>'
      + '</div>'
      + '<div class="lb-hint" id="lbHint">Tap to zoom · Pinch to zoom · Drag to pan</div>';
    document.body.appendChild(lb);

    document.getElementById('lbClose').addEventListener('click', window.cpCloseLightbox);
    lb.addEventListener('click', function (e) { if (e.target === lb) window.cpCloseLightbox(); });

    document.getElementById('lbZoomIn').addEventListener('click', function () { setLbScale(_lbScale + 0.5); });
    document.getElementById('lbZoomOut').addEventListener('click', function () { setLbScale(_lbScale - 0.5); });
    document.getElementById('lbZoomReset').addEventListener('click', function () { _lbPanX = 0; _lbPanY = 0; setLbScale(1); });

    var img = document.getElementById('lbImg');

    // Click to toggle zoom
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      if (_lbScale > 1) { _lbPanX = 0; _lbPanY = 0; setLbScale(1); }
      else { setLbScale(2.5); }
    });

    // Mouse drag pan
    img.addEventListener('mousedown', function (e) {
      if (_lbScale <= 1) return;
      _lbMouseDragging = true;
      _lbStartX = e.clientX - _lbPanX;
      _lbStartY = e.clientY - _lbPanY;
      img.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) {
      if (!_lbMouseDragging) return;
      _lbPanX = e.clientX - _lbStartX;
      _lbPanY = e.clientY - _lbStartY;
      applyLbTransform();
    });
    document.addEventListener('mouseup', function () {
      if (_lbMouseDragging) {
        _lbMouseDragging = false;
        var img2 = document.getElementById('lbImg');
        if (img2) img2.style.cursor = _lbScale > 1 ? 'grab' : 'zoom-in';
      }
    });

    // Touch pinch + pan
    var stage = document.getElementById('lbStage');
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        // Pinch start
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        _lbTouchDist = Math.sqrt(dx * dx + dy * dy);
        _lbScaleAtPinchStart = _lbScale;
        _lbTouchMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        _lbTouchMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        e.preventDefault();
      } else if (e.touches.length === 1 && _lbScale > 1) {
        // Pan start
        _lbTouchPanning = true;
        _lbTouchStartX = e.touches[0].clientX;
        _lbTouchStartY = e.touches[0].clientY;
        _lbPanXAtStart = _lbPanX;
        _lbPanYAtStart = _lbPanY;
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        var newDist = Math.sqrt(dx * dx + dy * dy);
        var ratio = newDist / _lbTouchDist;
        setLbScale(_lbScaleAtPinchStart * ratio);
        e.preventDefault();
      } else if (e.touches.length === 1 && _lbTouchPanning) {
        _lbPanX = _lbPanXAtStart + (e.touches[0].clientX - _lbTouchStartX);
        _lbPanY = _lbPanYAtStart + (e.touches[0].clientY - _lbTouchStartY);
        applyLbTransform();
        e.preventDefault();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) {
        // Single tap to toggle zoom (only if didn't pan far)
        if (!_lbTouchPanning && e.changedTouches.length === 1) {
          // handled by click event
        }
        _lbTouchPanning = false;
      }
    });

    // Double-tap to zoom
    var _lastTap = 0;
    stage.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - _lastTap < 300 && e.changedTouches.length === 1) {
        if (_lbScale > 1) { _lbPanX = 0; _lbPanY = 0; setLbScale(1); }
        else { setLbScale(2.5); }
        e.preventDefault();
      }
      _lastTap = now;
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('open')) window.cpCloseLightbox();
      if (lb.classList.contains('open')) {
        if (e.key === '+' || e.key === '=') setLbScale(_lbScale + 0.5);
        if (e.key === '-') setLbScale(_lbScale - 0.5);
      }
    });
  }

  function setLbScale(s) {
    _lbScale = Math.max(1, Math.min(5, s));
    if (_lbScale === 1) { _lbPanX = 0; _lbPanY = 0; }
    applyLbTransform();
    var hint = document.getElementById('lbHint');
    if (hint) hint.style.opacity = _lbScale > 1 ? '0' : '0.6';
  }
  function applyLbTransform() {
    var img = document.getElementById('lbImg');
    if (!img) return;
    img.style.transform = 'translate(' + _lbPanX + 'px,' + _lbPanY + 'px) scale(' + _lbScale + ')';
    img.style.cursor = _lbScale > 1 ? 'grab' : 'zoom-in';
  }
  window.cpOpenLightbox = function (src) {
    if (!src) return;
    ensureLightbox();
    var lb = document.getElementById('cpLightbox');
    var img = document.getElementById('lbImg');
    img.src = src;
    _lbPanX = 0; _lbPanY = 0; _lbScale = 1;
    applyLbTransform();
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    var hint = document.getElementById('lbHint');
    if (hint) hint.style.opacity = '0.6';
  };
  window.cpCloseLightbox = function () {
    var lb = document.getElementById('cpLightbox');
    if (lb) lb.classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ════════════════════════════════════════
     DETAIL TABLE — extensible row system
     Each row: { key, label, icon, type }
     type 'frame'  → clickable tabs (changes image)
     type 'size'   → display-only tabs
     type 'rooms'  → icon chips derived from product
  ════════════════════════════════════════ */
  var DETAIL_ROWS = [
    { key: 'frame', label: 'Frame',      icon: 'border-outer', type: 'frame' },
    { key: 'size',  label: 'Size',       icon: 'ruler-2',      type: 'size'  },
    { key: 'rooms', label: 'Best for',   icon: 'home',         type: 'rooms' }
    /* To add more rows in future, push here, e.g.:
    { key: 'medium', label: 'Medium', icon: 'brush', type: 'option' }
    */
  ];

  /* Derive room list from product title/tags keywords */
 function getRoomsForProduct(p) {
  var title = ((p && p.title) || '').toLowerCase();
  var tags  = ((p && p.tags) || []).map(function(t){ return t.toLowerCase(); });
  var collectionHandle = ((p && p.collection) || '').toLowerCase();
  var all = ' ' + title + ' ' + tags.join(' ') + ' ';

  var DEITY_NAMES = [
    'krishna','radha','shiv','shiva','ram','rama','hanuman','ganesh','ganesha',
    'durga','lakshmi','laxmi','saraswati','vishnu','jagannath','buddha','balaji',
    'tirupati','srinathji','shrinathji','kamdhenu','devi','goddess','jesus',
    'mahaveer jain','neem karoli','premanand','kedarnath','rudra','mahadev'
  ];
  function hasDeity() {
    return DEITY_NAMES.some(function(d){ return all.indexOf(d) !== -1; });
  }

  var ROOM_ICONS = {
    'Living Room': 'sofa',
    'Bedroom':     'bed',
    'Hall':        'building',
    'Kitchen':     'tool-kitchen-2',
    'Pooja Room':  'sparkles',
    'Study Room':  'book',
    'Home Office': 'briefcase',
    'Gaming Room': 'device-gamepad-2'
  };

  // ── Collection handle → room affinity (vastu & animal handled separately below) ──
  var COLLECTION_ROOM_MAP = {
    'warli-wall-art':            { 'Living Room':3, 'Hall':2, 'Study Room':1 },
    'office-wall-art':           { 'Home Office':4, 'Study Room':2 },
    'study-room-wall-art':       { 'Study Room':4, 'Home Office':2 },
    'shiv-ji-wall-art':          { 'Pooja Room':4, 'Living Room':2, 'Hall':1 },
    'car-wall-art':              { 'Gaming Room':3, 'Home Office':3, 'Bedroom':2 },
    'hindu-goddesses-wall-art':  { 'Pooja Room':4, 'Living Room':2 },
    'tirupati-bala-ji-wall-art': { 'Pooja Room':4, 'Living Room':1 },
    'abstract-wall-art':         { 'Living Room':3, 'Study Room':1 },
    'marvel-wall-art':           { 'Gaming Room':4, 'Bedroom':3, 'Home Office':1 },
    'hanuman-ji-wall-art':       { 'Pooja Room':4, 'Hall':2, 'Living Room':1 },
    'radha-krishna-wall-art':    { 'Pooja Room':4, 'Living Room':2 },
    'ram-ji-wall-art':           { 'Pooja Room':4, 'Hall':2, 'Living Room':1 },
    'cricket-motivation-wall-art': { 'Home Office':3, 'Gaming Room':3, 'Study Room':1 },
    'bohemian-wall-art':         { 'Living Room':3, 'Bedroom':2 },
    'shrinath-ji-wall-art':      { 'Pooja Room':4, 'Living Room':2 },
    'modern-hand-painting':      { 'Living Room':3, 'Study Room':1 },
    'waterfall-wall-art':        { 'Living Room':3, 'Hall':1, 'Bedroom':1 },
    'living-room-wall-art':      { 'Living Room':4 },
    'jagannath-ji-wall-art':     { 'Pooja Room':4, 'Living Room':1 },
    'floral-wall-art':           { 'Bedroom':2, 'Living Room':2 },
    'anime-wall-art':            { 'Gaming Room':4, 'Bedroom':3 },
    'buddha-wall-art':           { 'Living Room':3, 'Pooja Room':2, 'Hall':1 },
    'modern-wall-art':           { 'Living Room':3, 'Study Room':1 },
    'scenery-wall-painting':     { 'Living Room':3, 'Bedroom':1 },
    'kamdhenu-cow-wall-art':     { 'Pooja Room':3, 'Living Room':2 },
    'movies-and-anime-wall-art': { 'Gaming Room':4, 'Bedroom':3 },
    'eclectic-wall-art':         { 'Living Room':2, 'Study Room':1 },
    'varanasi-ghat':             { 'Living Room':2, 'Hall':2, 'Pooja Room':1 },
    'boho-wall-art':             { 'Living Room':3, 'Bedroom':2 },
    'running-horses-wall-art':   { 'Hall':3, 'Living Room':2, 'Home Office':1 },
    'space-motivation-wall-art': { 'Home Office':3, 'Study Room':2, 'Gaming Room':2, 'Bedroom':1 },
    'joker-wall-art':            { 'Gaming Room':4, 'Bedroom':2, 'Home Office':1 },
    'peacock-wall-art':          { 'Living Room':2, 'Hall':2 },
    'vintage-wall-art':          { 'Living Room':2, 'Study Room':1 },
    'motivational-wall-art':     { 'Home Office':4, 'Study Room':2, 'Gaming Room':1 },
    'african-wall-art':         { 'Living Room':2, 'Hall':1 },
    'phoenix-wall-art':          { 'Living Room':2, 'Home Office':2, 'Gaming Room':1, 'Hall':1 },
    'traditional-wall-art':      { 'Living Room':2, 'Pooja Room':1 },
    'pichwai-wall-art':          { 'Pooja Room':4, 'Living Room':2 }
    // NOTE: 'animal-wall-art' intentionally removed — handled by the dedicated
    // animal-subject layer below, which distinguishes wildlife/nature from stylized pop-art
  };

  var rooms = {};
  Object.keys(ROOM_ICONS).forEach(function(r){ rooms[r] = { icon: ROOM_ICONS[r], score: 0 }; });
  function bump(room, pts) { if (rooms[room]) rooms[room].score += pts; }

  // ── Character / icon / brand dictionaries (from real catalog titles) ──
  var CHARACTER_NAMES = {
    'goku':3,'vegeta':3,'luffy':3,'naruto':3,'sasuke':3,'itachi':3,'kakashi':3,
    'tanjiro':3,'rengoku':3,'demon slayer':3,'eren':3,'attack on titan':3,'pikachu':3,
    'spiderman':3,'spider-man':3,'spider man':3,'ironman':3,'iron man':3,'thor':3,
    'thanos':3,'captain america':3,'captain marvel':3,'dr doom':3,'doctor doom':3,
    'batman':3,'joker':3,'superman':3,
    'james bond':3,'pink panther':2,'squid game':3,'red dead redemption':3
  };
  var SPORTS_ICONS = {
    'virat kohli':3,'rohit sharma':3,'ms dhoni':3,'dhoni':3,'cristiano ronaldo':3,
    'ronaldo':3,'michael jordan':3,'lebron james':3,'lebron':3
  };
  var CULTURAL_ICONS = {
    'leonardo dicaprio':2,'dicaprio':2,'elon musk':2,'warren buffett':2,
    'marilyn monroe':2,'michael jackson':2,'bob marley':2,'napoleon':2,
    'mona lisa':2,'godfather':2,'thomas shelby':2,
    'donald duck':2,'mickey mouse':2,'winnie the pooh':2,'scrooge mcduck':2
  };
  var CAR_BRANDS = ['porsche','ferrari','lamborghini','audi','mercedes','harley davidson','formula1','formula 1','f1 car'];
  var VASTU_MOTIFS = ['running horse','peacock','phoenix','kamdhenu','goldfish','sri yantra','yantra'];
  var ANIMAL_WORDS = ['lion','tiger','elephant','giraffe','leopard','zebra','swan','parrot','wildlife','animal'];
  var POP_ANIMAL_CUES = ['suit','cigar','sunglasses','mafia','gangster','smoking','blazer','gentleman','baseball','peaky blinder','money','dollar'];

  // ── Layer 1: primary collection match (vastu handled conditionally) ──
  if (collectionHandle === 'vastu-wall-art') {
    if (hasDeity()) {
      bump('Pooja Room', 4);
      bump('Living Room', 2);
    } else if (VASTU_MOTIFS.some(function(m){ return all.indexOf(m) !== -1; })) {
      bump('Hall', 3);
      bump('Living Room', 2);
    } else {
      bump('Hall', 2);
      bump('Living Room', 2);
    }
  } else if (collectionHandle && COLLECTION_ROOM_MAP[collectionHandle]) {
    var primaryMap = COLLECTION_ROOM_MAP[collectionHandle];
    Object.keys(primaryMap).forEach(function(r){ bump(r, primaryMap[r]); });
  }

  // ── Layer 2: secondary theme match via title/tags (half weight) ──
  Object.keys(COLLECTION_ROOM_MAP).forEach(function(handle){
    if (handle === collectionHandle) return;
    var keyword = handle.replace('-wall-art', '').replace(/-/g, ' ');
    if (all.indexOf(keyword) !== -1) {
      var secMap = COLLECTION_ROOM_MAP[handle];
      Object.keys(secMap).forEach(function(r){ bump(r, Math.ceil(secMap[r] / 2)); });
    }
  });
  if (collectionHandle !== 'vastu-wall-art' && all.indexOf('vastu') !== -1) {
    if (hasDeity()) { bump('Pooja Room', 2); }
    else { bump('Hall', 2); bump('Living Room', 1); }
  }

  // ── Layer 3: character / movie / icon / brand detection ──
  Object.keys(CHARACTER_NAMES).forEach(function(name){
    if (all.indexOf(name) !== -1) {
      bump('Gaming Room', CHARACTER_NAMES[name]);
      bump('Bedroom', CHARACTER_NAMES[name] - 1);
    }
  });
  Object.keys(SPORTS_ICONS).forEach(function(name){
    if (all.indexOf(name) !== -1) {
      bump('Home Office', SPORTS_ICONS[name]);
      bump('Gaming Room', SPORTS_ICONS[name] - 1);
    }
  });
  Object.keys(CULTURAL_ICONS).forEach(function(name){
    if (all.indexOf(name) !== -1) {
      var pts = CULTURAL_ICONS[name];
      bump('Living Room', pts);
      bump('Home Office', Math.max(1, pts - 1));
      bump('Bedroom', Math.max(1, pts - 1)); // movies/pop-culture pieces suit bedrooms too
    }
  });
  CAR_BRANDS.forEach(function(brand){
    if (all.indexOf(brand) !== -1) {
      bump('Gaming Room', 2);
      bump('Home Office', 2);
      bump('Bedroom', 1);
    }
  });

  // ── Layer 4: animal subject — split realistic wildlife vs stylized pop-art ──
  var hasAnimalSubject = collectionHandle === 'animal-wall-art' ||
    ANIMAL_WORDS.some(function(w){ return all.indexOf(w) !== -1; });
  if (hasAnimalSubject) {
    var isStylizedAnimal = POP_ANIMAL_CUES.some(function(c){ return all.indexOf(c) !== -1; });
    if (isStylizedAnimal) {
      bump('Gaming Room', 3);
      bump('Bedroom', 2);
      bump('Home Office', 1);
    } else {
      bump('Living Room', 2);
      bump('Hall', 2);
    }
  }

  // ── Layer 5: abstract tone detection ──
  if (collectionHandle === 'abstract-wall-art' || all.indexOf('abstract') !== -1) {
    var calmWords = ['pastel','muted','soft','calm','serene','tranquil','minimal','minimalist','monochrome'];
    var boldWords = ['vibrant','bold','bright','colorful','vivid','striking'];
    var isCalm = calmWords.some(function(w){ return all.indexOf(w) !== -1; });
    var isBold = boldWords.some(function(w){ return all.indexOf(w) !== -1; });
    if (isCalm && !isBold) { bump('Bedroom', 3); }
    else if (isBold) { bump('Living Room', 1); bump('Home Office', 1); }
  }

  // ── Layer 6: "Set of 3" / multi-panel detector ──
  if (all.indexOf('set of') !== -1) {
    bump('Home Office', 2);
    bump('Living Room', 2);
  }

  // ── Layer 7: explicit room name mention (strong override) ──
  var directSignals = [
    { room: 'Living Room', keys: ['living room', 'lounge', 'sitting room'] },
    { room: 'Bedroom',     keys: ['bedroom', 'bed room', 'master room'] },
    { room: 'Hall',        keys: ['hall', 'foyer', 'entryway', 'entry', 'corridor', 'passage'] },
    { room: 'Kitchen',     keys: ['kitchen', 'dining room'] },
    { room: 'Pooja Room',  keys: ['pooja room', 'puja room', 'mandir', 'altar'] },
    { room: 'Study Room',  keys: ['study room', 'study', 'library'] },
    { room: 'Home Office', keys: ['home office', 'office', 'workspace'] },
    { room: 'Gaming Room', keys: ['gaming room', 'game room', 'gamer'] }
  ];
  directSignals.forEach(function(s){
    s.keys.forEach(function(k){ if (all.indexOf(k) !== -1) bump(s.room, 5); });
  });

  // ── Rank using a percentage threshold (scales correctly regardless of score magnitude) ──
  var ranked = Object.keys(rooms)
    .map(function(name){ return { label: name, icon: rooms[name].icon, score: rooms[name].score }; })
    .filter(function(r){ return r.score > 0; })
    .sort(function(a, b){ return b.score - a.score; });

  var topScore = ranked.length ? ranked[0].score : 0;
  var result = topScore > 0
    ? ranked.filter(function(r){ return r.score >= topScore * 0.5; }).slice(0, 3)
    : [];

  if (!result.length) {
    result = [
      { label: 'Living Room', icon: 'sofa' },
      { label: 'Hall', icon: 'building' }
    ];
  }
  return result;
}
  /* Build the per-product image + table card (no title shown) */
  function buildOptionCards() {
    var pA = items[slotA];
    var pB = items[slotB];
    if (!pA || !pB || slotA === slotB) return '';

    function cardHTML(p, idx, side) {
  var imgSrc = slotImage(idx);
  return '<div class="spec-card">'
    + '<div class="spec-card-name">' + p.title + '</div>'
    + '<div class="variant-img-wrap">'
          + '<img id="vimg-' + side + '" src="' + imgSrc + '" alt="' + p.title + '">'
        + '</div>'
        + '<table class="detail-table" id="dtable-' + side + '">'
          + '<tbody>'
            + DETAIL_ROWS.map(function(row){
                return '<tr>'
                  + '<td class="dt-label"><span class="dt-icon"><i class="ti ti-' + row.icon + '"></i></span>' + row.label + '</td>'
                  + '<td class="dt-val" id="dt-' + side + '-' + row.key + '"><span class="dt-loading">—</span></td>'
                + '</tr>';
              }).join('')
          + '</tbody>'
        + '</table>'
      + '</div>';
    }

    return '<div class="spec-cols">' + cardHTML(pA, slotA, 'A') + cardHTML(pB, slotB, 'B') + '</div>';
  }

  /* ── build actions ── */
  function buildActions() {
    var pA = items[slotA];
    var pB = items[slotB];
    if (!pA || !pB || slotA === slotB) return '';
    function pairHTML(p) {
      return '<div><a href="' + p.url + '" class="btn-outline">Buy artwork →</a></div>';
    }
    return '<div class="action-pair-cols">' + pairHTML(pA) + pairHTML(pB) + '</div>';
  }

  /* ── build see more — pulls from BOTH compared products' collections, randomized ── */
  function buildSeeMore() {
    var pA = items[slotA];
    var pB = items[slotB];
    var collA = pA && pA.collection ? pA.collection : null;
    var collB = pB && pB.collection ? pB.collection : null;

    var collections = [];
    if (collA) collections.push(collA);
    if (collB && collB !== collA) collections.push(collB);
    if (!collections.length) return '';

    var compareIds = items.map(function (i) { return i.id; });

    setTimeout(function () {
      var grid = document.getElementById('seeMoreGrid');
      if (!grid) return;

      Promise.all(collections.map(function (handle) {
        return fetch('/collections/' + handle + '/products.json?limit=16')
          .then(function (r) { return r.json(); })
          .then(function (data) { return (data.products || []).map(function (p) { p._collectionHandle = handle; return p; }); })
          .catch(function () { return []; });
      })).then(function (results) {
        var grid = document.getElementById('seeMoreGrid');
        if (!grid) return;

        // merge + de-dupe across both collections, excluding items already being compared
        var merged = [];
        var seen = {};
        results.forEach(function (list) {
          list.forEach(function (p) {
            if (!seen[p.id] && compareIds.indexOf(p.id) === -1) {
              seen[p.id] = true;
              merged.push(p);
            }
          });
        });

        // shuffle (Fisher–Yates) so it's not the same set every time
        for (var i = merged.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = merged[i]; merged[i] = merged[j]; merged[j] = tmp;
        }

        var products = merged.slice(0, 4);
        if (!products.length) {
          var sec = document.getElementById('seeMoreSection');
          if (sec) sec.style.display = 'none';
          return;
        }

        grid.innerHTML = products.map(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          var safeTitle = p.title.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
          var safeImg = img.replace(/'/g, "\\'");
          var safeCollection = (p._collectionHandle || collections[0]).replace(/'/g, "\\'");
          return '<a class="sm-card" href="/products/' + p.handle + '">'
            + (img ? '<img src="' + img + '" alt="' + p.title + '">' : '')
            + '<div class="sm-card-info">'
              + '<div class="sm-card-name">' + shortTitle(p.title, 28) + '</div>'
              + '<button class="sm-card-btn" onclick="event.preventDefault();event.stopPropagation();cpAddFromGrid(' + p.id + ',\'' + safeTitle + '\',\'' + safeImg + '\',\'' + p.handle + '\',\'\',\'' + safeCollection + '\')">'
              + '+ Add to compare</button>'
            + '</div></a>';
        }).join('');
      });
    }, 50);

    return '<div id="seeMoreSection">'
      + '<p class="cp-section">You might also like</p>'
      + '<div class="see-more-grid" id="seeMoreGrid">'
        + '<div style="color:#5A5754;font-size:13px;padding:10px 0;grid-column:1/-1;">Loading…</div>'
      + '</div></div>';
  }

  /* ════════════════════════════════════════
     RENDER
  ════════════════════════════════════════ */
  function render() {
    items = getItems();
    slotA = Math.min(slotA, items.length - 1);
    slotB = Math.min(slotB, items.length - 1);
    if (slotA === slotB && items.length > 1) slotB = slotA === 0 ? 1 : 0;

    root.innerHTML =
      '<div class="cp-topbar">'
        + '<button class="cp-clear" onclick="cpClear()">Clear all</button>'
      + '</div>'
      + '<p class="cp-section">Saved for comparison</p>'
      + buildSavedCarousel()
      + buildSwapHint()
      + '<p class="cp-section">Comparing</p>'
      + buildCompareCols()
      + '<p class="cp-section">Side by side</p>'
      + buildReveal()
      + '<p class="cp-section">Artwork details</p>'
      + buildOptionCards()
      + buildActions()
      + buildSeeMore();

    var carouselOuter = document.getElementById('cpCarouselOuter');
    if (carouselOuter) initCarousel(carouselOuter);

    initSlider();
    loadFramePickers();
  }

  /* ── reveal slider drag ── */
  function initSlider() {
    var arena = document.getElementById('revealArena');
    if (!arena) return;
    var revealTop = document.getElementById('revealTop');
    var revealLine = document.getElementById('revealLine');
    var revealHandle = document.getElementById('revealHandle');
    var dragging = false;

    function setPos(clientX) {
      var rect = arena.getBoundingClientRect();
      var pct = Math.max(3, Math.min(97, ((clientX - rect.left) / rect.width) * 100));
      revealTop.style.clipPath = 'inset(0 ' + (100 - pct).toFixed(2) + '% 0 0)';
      revealLine.style.left = pct + '%';
      revealHandle.style.left = pct + '%';
    }
    arena.addEventListener('mousedown', function (e) {
      if (e.target.closest('.reveal-zoom')) return;
      dragging = true; setPos(e.clientX); e.preventDefault();
    });
    arena.addEventListener('touchstart', function (e) {
      if (e.target.closest('.reveal-zoom')) return;
      dragging = true; setPos(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
    document.addEventListener('touchmove', function (e) { if (dragging) { setPos(e.touches[0].clientX); e.preventDefault(); } }, { passive: false });
    document.addEventListener('mouseup', function () { dragging = false; });
    document.addEventListener('touchend', function () { dragging = false; });
  }

  /* ── interactions ── */
  window.cpSelectSlot = function (side) {
    _selectedSlot = (_selectedSlot === side) ? null : side;
    render();
  };
  window.cpClickThumb = function (index) {
    if (_selectedSlot !== null) {
      if (_selectedSlot === 'A') { if (index === slotB) slotB = slotA; slotA = index; }
      else { if (index === slotA) slotA = slotB; slotB = index; }
      _selectedSlot = null; render(); return;
    }
    if (index === slotA || index === slotB) return;
    slotB = index; render();
  };
  window.cpDragStart = function (e, index) {
    _dragIndex = index; _selectedSlot = null;
    e.currentTarget.classList.add('dragging');
    e.dataTransfer.effectAllowed = 'move';
  };
  window.cpDragEnd = function (e) {
    e.currentTarget.classList.remove('dragging');
    document.querySelectorAll('.compare-slot').forEach(function (el) { el.classList.remove('drag-over'); });
  };
  window.cpDrop = function (e, side) {
    e.preventDefault();
    var el = document.getElementById('slot' + side);
    if (el) el.classList.remove('drag-over');
    if (_dragIndex === -1) return;
    if (side === 'A') { if (_dragIndex === slotB) slotB = slotA; slotA = _dragIndex; }
    else { if (_dragIndex === slotA) slotA = slotB; slotB = _dragIndex; }
    _dragIndex = -1; render();
  };
  window.cpClearSlot = function (isSlotA) {
    var other = isSlotA ? slotB : slotA;
    var next = -1;
    for (var i = 0; i < items.length; i++) { if (i !== other) { next = i; break; } }
    if (next === -1) return;
    if (isSlotA) slotA = next; else slotB = next;
    _selectedSlot = null; render();
  };
  window.cpRemoveItem = function (index) {
    items.splice(index, 1);
    localStorage.setItem('compareItems', JSON.stringify(items));
    if (typeof window.updateCompareIcon === 'function') window.updateCompareIcon();
    if (items.length === 0) {
      root.innerHTML = '<div class="empty-state"><p>No products added to compare.</p><a href="/collections/explore-all-wall-art">Browse products</a></div>';
      return;
    }
    slotA = Math.min(slotA, items.length - 1);
    slotB = Math.min(slotB, items.length - 1);
    if (slotA === slotB) slotB = slotA === 0 ? Math.min(1, items.length - 1) : 0;
    _selectedSlot = null; render();
  };
  window.cpAddFromGrid = function (id, title, image, handle, price, collection) {
    items = getItems();
    if (items.some(function (i) { return i.id === id; })) return;
    if (items.length >= 5) { alert('Maximum 5 products. Remove one first.'); return; }
    items.push({ id: id, title: title, image: image, url: '/products/' + handle, handle: handle, options: [], collection: collection });
    localStorage.setItem('compareItems', JSON.stringify(items));
    if (typeof window.updateCompareIcon === 'function') window.updateCompareIcon();
    render();
  };
  window.cpClear = function () {
    localStorage.removeItem('compareItems');
    if (typeof window.updateCompareIcon === 'function') window.updateCompareIcon();
    window.location.href = '/collections/all';
  };

  /* ── MutationObserver keeps blip in sync ── */
  setTimeout(function () {
    var drawerEl = document.querySelector('#drawer-cart');
    if (drawerEl && !window._cpCartObserver) {
      window._cpCartObserver = new MutationObserver(function () {
        clearTimeout(window._cpCartObserverTimer);
        window._cpCartObserverTimer = setTimeout(function () {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateBlip(cart.item_count);
              refreshProgressBar();
            });
        }, 300);
      });
      window._cpCartObserver.observe(drawerEl, { childList: true, subtree: true });
    }
  }, 500);

  render();
})();